import { actions } from "./state";

export const changePagePropsInputTagihan = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_INPUT_TAGIHAN,
    payload: props,
  };
};

export const changePagePropsInputRekapTagihan = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_INPUT_REKAP_TAGIHAN,
    payload: props,
  };
};

export const changePagePropsInputPenjualan = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_INPUT_PENJUALAN,
    payload: props,
  };
};

export const changePagePropsWfPurchaseOrder = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_WF_PURCHASE_ORDER,
    payload: props,
  };
};

export const changePagePropsWfMutasiItem = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_WF_MUTASI_ITEM,
    payload: props,
  };
};

export const changePagePropsJurnalUmum = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_JURNAL_UMUM,
    payload: props,
  };
};

export const changePagePropsNeracaBulanDetail = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_NERACA_BULAN_DETAIL,
    payload: props,
  };
};

export const changePagePropsLabaRugiDetail = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_LABA_RUGI_DETAIL,
    payload: props,
  };
};

export const changePagePropsDetailRekapJasmed = (props) => {
  return {
    type: actions.CHANGE_PROPS_PAGE_DETAIL_REKAP_JASMED,
    payload: props,
  };
};

export const changeTabs = (props) => {
  return {
    type: actions.CHANGE_TABS,
    payload: props,
  };
};

export const changeMinimize = (props) => {
  return {
    type: actions.CHANGE_MINIMIZE,
    payload: props,
  };
};

export const resetPageProps = (props) => {
  return {
    type: actions.RESET_PAGE_PROPS,
    payload: props,
  };
};

export const changeLoading = (props) => {
  return {
    type: actions.CHANGE_LOADING,
    payload: props,
  };
};

export const changeActiveTab = (props) => {
  return {
    type: actions.CHANGE_ACTIVE_TAB,
    payload: props,
  };
};

export const changeInsuranceBpjsID = (props) => {
  return {
    type: actions.CHANGE_INSURANCE_BPJS_ID,
    payload: props,
  };
};

export const changeActiveMenu = (props) => {
  return {
    type: actions.CHANGE_ACTIVE_MENU,
    payload: props,
  };
};

export const changePageProps = (props) => {
  return {
    type: actions.CHANGE_PAGE_PROPS,
    payload: props,
  };
};

export const changeNotifikasiList = (props) => {
  return {
    type: actions.CHANGE_NOTIFIKASI_LIST,
    payload: props,
  };
};

export const changeNotifikasiCount = (props) => {
  return {
    type: actions.CHANGE_NOTIFIKASI_COUNT,
    payload: props,
  };
};

export const changeTheme = (props) => {
  return {
    type: actions.CHANGE_PROPS_THEME,
    payload: props,
  };
};